// Action types
export const ACTIONS = {
  SET_FILE: 'SET_FILE',
  SET_WARPED_SVG: 'SET_WARPED_SVG',
  RESET_STATE: 'RESET_STATE',
  SET_DESIGN_PATTERNS: 'SET_DESIGN_PATTERNS',
  SET_DESIGN_PATTERN_ID: 'SET_DESIGN_PATTERN_ID',
  SET_MAPPING_DATA: 'SET_MAPPING_DATA',
  SET_PROFILE_CONFIGS: 'SET_PROFILE_CONFIGS',
  UPDATE_PROFILE_CONFIG: 'UPDATE_PROFILE_CONFIG',
  SET_PROFILES: 'SET_PROFILES',
  SET_INSIDE_FEATURE: 'SET_INSIDE_FEATURE',
  RESET_MANUAL_WARP_DATA: 'RESET_MANUAL_WARP_DATA',
};

// Initial state
export const initialDesignPatternState = {
  svgFile: null,
  warpedSvg: null,
  designPatternId: null,
  designPatterns: [],
  designPatternLoading: false,
  designPatternError: null,
  mappingData: null,
  profileConfigs: null,
  profiles: [],
  insideFeature: false
};

// Reducer function
const studioReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_FILE:
      return {
        ...state,
        svgFile: action.payload
      };
    case ACTIONS.SET_WARPED_SVG:
      return {
        ...state,
        warpedSvg: action.payload
      };
    case ACTIONS.SET_PROFILES:
      return {
        ...state,
        profiles: action.payload
      };
    case ACTIONS.RESET_STATE:
      return initialDesignPatternState;
    case ACTIONS.SET_DESIGN_PATTERNS:
      return {
        ...state,
        designPatterns: action.payload
      };
    case ACTIONS.SET_DESIGN_PATTERN_ID:
      return {
        ...state,
        designPatternId: action.payload
      };
    case ACTIONS.SET_MAPPING_DATA:
      return {
        ...state,
        mappingData: {
          ...(state.mappingData ? state.mappingData : {}),
          ...action.payload,
        },
      };
    case ACTIONS.SET_PROFILE_CONFIGS:
      return {
        ...state,
        profileConfigs: action.payload
      };

    case ACTIONS.UPDATE_PROFILE_CONFIG:
      return {
        ...state,
        profileConfigs: {
          ...state.profileConfigs,
          [action.payload.profileId]: {
            ...state.profileConfigs[action.payload.profileId],
            ...action.payload.configs
          }
        }
      };
    case ACTIONS.SET_INSIDE_FEATURE:
      return {
        ...state,
        insideFeature: action.payload
      };
    case ACTIONS.RESET_MANUAL_WARP_DATA:
      // Reset manual warp related keys for all profiles and widths
      if (!state.profileConfigs) return state;

      const resetProfileConfigs = Object.keys(state.profileConfigs).reduce((acc, profileId) => {
        const profileConfig = state.profileConfigs[profileId];
        acc[profileId] = Object.keys(profileConfig).reduce((widthAcc, widthId) => {
          const widthConfig = profileConfig[widthId];
          widthAcc[widthId] = {
            ...widthConfig,
            config: {
              ...widthConfig.config,
              base_config: widthConfig.config?.base_config ? {
                ...widthConfig.config.base_config,
                manualWarp: {
                  isEnabled: false,
                  viewBoxScale: 1,
                  meshComplexity: 3,
                  interpolation: 50,
                  controlPoints: [],
                  manualWarpSvg: "",
                  patternPosition: { x: 0, y: 0 },
                  warpOffset: { warpTranslateX: 0, warpTranslateY: 0, warpScale: 1 },
                  patternScale: 1,
                  history: [],
                  historyIndex: -1,
                }
              } : widthConfig.config?.base_config,
              inside_config: widthConfig.config?.inside_config ? {
                ...widthConfig.config.inside_config,
                manualWarp: {
                  isEnabled: false,
                  meshComplexity: 3,
                  interpolation: 50,
                  controlPoints: [],
                  manualWarpSvg: "",
                  viewBoxScale: 1,
                  patternPosition: { x: 0, y: 0 },
                  warpOffset: { warpTranslateX: 0, warpTranslateY: 0, warpScale: 1 },
                  patternScale: 1,
                  history: [],
                  historyIndex: -1,
                }
              } : widthConfig.config?.inside_config,
            }
          };
          return widthAcc;
        }, {});
        return acc;
      }, {});

      return {
        ...state,
        profileConfigs: resetProfileConfigs
      };
    default:
      return state;
  }
};

export default studioReducer;